import { render, staticRenderFns } from "./vr-compose.vue?vue&type=template&id=4a0f93e8&scoped=true"
import script from "./vr-compose.vue?vue&type=script&lang=js"
export * from "./vr-compose.vue?vue&type=script&lang=js"
import style0 from "./vr-compose.vue?vue&type=style&index=0&id=4a0f93e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f93e8",
  null
  
)

export default component.exports